<script>
import MarkdownIt from 'markdown-it'
import changelog from '!!raw-loader!../../CHANGELOG.md'
import LargeTabHeader from '@/components/common/tabs/LargeTabHeader.vue'
import { copyToClipboard } from '@/helpers/clipboard'

export default {
  name: 'Changelog',
  components: { LargeTabHeader },
  data() {
    return {
      changelogHtml: '<p>Lade Changelog...</p>',
      services: [
        {
          name: 'User Service',
          icon: 'mdi-account',
          version: '',
          url: window?.config?.VUE_APP_API_BASE_URL,
          status: 'up'
        },
        {
          name: 'Upload Service',
          icon: 'mdi-upload',
          version: '',
          url: window?.config?.VUE_APP_UPLOAD_API_BASE_URL,
          status: 'down'
        },
        {
          name: 'Order Service',
          icon: 'mdi-order-bool-ascending',
          version: '',
          url: window?.config?.VUE_APP_ORDER_API_BASE_URL,
          status: 'up'
        },
        {
          name: 'Jobs Service',
          icon: 'mdi-server',
          version: '',
          url: window?.config?.VUE_APP_JOBS_API_BASE_URL,
          status: 'up'
        }
      ]
    }
  },
  mounted() {
    this.markdownifyChangelog()
    this.checkServiceStatus()
  },
  methods: {
    copyToClipboard,
    markdownifyChangelog() {
      const md = new MarkdownIt()
      md.set({ html: true, linkify: true, typographer: true })

      md.renderer.rules.link_open = (tokens, idx, options, env, self) => {
        const aIndex = tokens[idx].attrIndex('target')
        if (aIndex < 0) {
          tokens[idx].attrPush(['target', '_blank'])
        } else {
          tokens[idx].attrs[aIndex][1] = '_blank'
        }
        return self.renderToken(tokens, idx, options)
      }
      this.changelogHtml = md.render(changelog)
    },
    async checkServiceStatus() {
      const updatedServices = await Promise.all(this.services.map(async service => {
        let version = service?.version
        let status = 'down'

        try {
          // Version check
          const versionResponse = await fetch(`${service?.url}/version`, { method: 'GET' })
          if (versionResponse.ok) {
            const versionText = await versionResponse?.text()
            version = JSON.parse(versionText?.trim())?.version
          }
          // Health check
          const healthResponse = await fetch(`${service?.url?.replace(/\/api$/, '')}/healthz/ready`, { method: 'GET' })
          const response = await healthResponse?.json()
          if (response.status === 'Healthy') {
          // if (healthResponse?.ok) {
            status = 'up'
          }
        } catch (error) {
          console.warn(`Service ${service?.name} unreachable:`, error)
          status = 'down'
        }
        return {
          ...service,
          version,
          status
        }
      }))
      this.services = updatedServices
    }
  }
}
</script>

<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card>
          <LargeTabHeader
            title="Versionshinweise"
            subtitle="Hier finden Sie Informationen zur aktuellen Entwicklung sowie Fixes und Features vergangener Versionen."
          />
          <v-divider></v-divider>
          <v-card-text>
            <v-container>
              <v-row justify="center">
                <v-col cols="auto" class="text-center">
                  <v-chip-group class="d-flex flex-wrap justify-center">
                    <v-chip
                      v-for="(service, index) in services"
                      :key="index"
                      class="d-flex align-center"
                      color="secondary"
                      text-color="white"
                      style="padding-right: 10px"
                      @click="copyToClipboard(service.name + ' ' + service.version)">
                      <span
                        :style="{
                          backgroundColor:
                            service.status === 'up' ? '#4CAF50' : '#F44336',
                          borderRadius: '50%',
                          display: 'inline-block',
                          width: '10px',
                          height: '10px',
                          marginRight: '8px'
                        }"></span>
                      <v-icon small class="mr-1">{{ service.icon }}</v-icon>
                      {{ service.name }}
                      <span
                        class="ml-2"
                        style="font-size: 0.75rem; color: rgba(255, 255, 255, 0.7);">
                        {{ service.version }}
                      </span>
                    </v-chip>
                  </v-chip-group>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-text>
            <v-container>
              <div class="changelog-container" v-html="changelogHtml"></div>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
.changelog-container {
  line-height: 1.6;
}

.changelog-container h1,
.changelog-container h2,
.changelog-container h3 {
  margin-top: 1.5rem;
  margin-bottom: 1rem;
}

.changelog-container ul {
  list-style: disc;
  padding-left: 1.5rem;
}
</style>
